"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const object_case_converter_1 = require("@ridi/object-case-converter");
const app_platform_version_1 = require("@semios/app-platform-version");
const axios_1 = __importDefault(require("axios"));
const is_url_1 = __importDefault(require("is-url"));
const lodash_1 = __importStar(require("lodash"));
const proper_url_join_1 = __importDefault(require("proper-url-join"));
const common_1 = require("../types/common");
const util_1 = require("../util");
const { GET } = util_1.httpMethods;
/**
 * @classdesc Represents the class facilitating interaction with API-I
 * @class
 */
class ApiCall {
    /**
     * Create a API Call.
     * @constructor
     * @param {string} baseUrl - A string with the base url for the domain
     * @param {string} authenticationToken - The authentication token allowing access
     */
    constructor(baseUrl, authenticationToken) {
        // check and set base url
        if ((0, is_url_1.default)(baseUrl)) {
            this.baseUrl = baseUrl;
        }
        else {
            throw (0, util_1.createJSONStringifiedError)((0, util_1.setErrResponse)('The base Url provided is not valid'));
        }
        // check and set authentication token
        if (lodash_1.default.isString(authenticationToken)) {
            this.authenticationToken = authenticationToken;
        }
        else {
            throw (0, util_1.createJSONStringifiedError)((0, util_1.setErrResponse)('No authentication token found'));
        }
    }
    /**
     * Fetch the information from the API.
     * @return {Promise} - Returns a Promise that, when fulfilled, will either return the requested data or an Error object with the problem.
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    async send(method, route, input = {}) {
        const { header: { customerId } = {}, query: params, body: data } = input;
        const callUrl = (0, proper_url_join_1.default)(this.baseUrl, route, { trailingSlash: false });
        const headers = {
            'User-Agent': `app-platform-internal-api-sdk/${app_platform_version_1.APP_PLATFORM_VERSION}`,
            'Content-Type': 'application/json',
        };
        headers.Authorization = `Api-Key ${this.authenticationToken}`;
        if (customerId)
            headers['Customer-Identifier'] = customerId.toString();
        const config = {
            headers,
            method,
            params,
        };
        if (method !== GET)
            config.data = data;
        let response;
        try {
            response = await (0, axios_1.default)(callUrl, config);
            if ([200, 201].includes(response.status)) {
                let camelizedData = (0, object_case_converter_1.camelize)(response.data, { recursive: true });
                // Camel-case exceptions
                if (route.match(/properties\/([0-9,]+)\/(nodes|gateways)\/logs/) ||
                    route.match(/nodes\/service_issues\/issue_type\/([0-9,]+)\/resolution_actions/) ||
                    route.match(/nodes\/common\/([0-9A-Z,]+)\/config/)) {
                    // Node logs are indexed by node ids, so we need to revert the keys camelization
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    camelizedData = (0, lodash_1.mapKeys)(camelizedData, (_, key) => (0, util_1.transformToUpperUnderscore)(key));
                }
                return camelizedData;
            }
            return {};
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
        }
        catch (e) {
            if (e.response) {
                // axios will treat 4xx & 5xx responses as errors. Handle and return as a rejected promise.
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const { status: resStatus, statusText: resStatusText, data: resData } = e.response;
                if (resStatus === 404 && resData.message === 'The requested resource could not be found.') {
                    return Promise.reject(new common_1.ApiInternalError(`API-I SDK error: unknown path (${method} ${route})`, 500));
                }
                const errMessage = resData?.message || resStatusText.replace(/\s+/g, '');
                return Promise.reject(new common_1.ApiInternalError(errMessage, resStatus, resData));
            }
            else {
                return Promise.reject((0, util_1.createJSONStringifiedError)((0, util_1.setErrResponse)(`An error occurred while fetching data: ${e.code}`)));
            }
        }
    }
}
exports.default = ApiCall;
//# sourceMappingURL=api.js.map